<template>
  <!-- <CSidebar 
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
    colorScheme="light"
    style="background-color: #40568a50;"
  > -->
  <CSidebar 
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
    colorScheme="light"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <img
        class="c-sidebar-brand-full" 
        src="logo/logo-ev-fill-h50.png"
      />
      <img
        class="c-sidebar-brand-minimized" 
        src="logo/logo-ev-mini-h50.png"
      />


      <!-- ### Core UI Logo -->
      <!-- <CIcon 
        class="c-sidebar-brand-full" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        viewBox="0 0 556 134"
      />
      <CIcon 
        class="c-sidebar-brand-minimized" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        viewBox="0 0 110 134"
      /> -->
      <!-- ### MECAs Logo -->
      <!-- <CIcon 
        class="c-sidebar-brand-full" 
        name="logo" 
        size="custom-size" 
        :height="30" 
        viewBox="0 0 2455 505"
      />
      <CIcon 
        class="c-sidebar-brand-minimized" 
        name="logo" 
        size="custom-size" 
        :height="30" 
        viewBox="0 0 785 505"
      /> -->
    </CSidebarBrand>

    <!-- <CRenderFunction flat :content-to-render="$options.nav"/> -->
    <CRenderFunction flat :content-to-render="menu"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from './_nav'
// import { mapState } from 'vuex'

export default {
  name: 'TheSidebar',
  nav,
  data() {
    return {
      menu: [],
      publicMenu: [
        {
          _name: 'CSidebarNavItem',
          name: 'Home',
          to: '/home',
          icon: 'cil-home'
        },
        // {
        //   _name: 'CSidebarNavItem',
        //   name: 'Dashboard',
        //   to: '/dashboard',
        //   icon: 'cil-speedometer'
        // },
      ],
      userMenu: [
        {
          _name: 'CSidebarNavTitle',
          _children: ['EV Tranformation']
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Document',
          to: 'document',
          icon: 'cil-info'
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Info',
          to: '/info',
          icon: 'cil-user'
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Plan',
          to: '/plan',
          icon: 'cil-spreadsheet'
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Vehicle',
          to: '/vehicle',
          icon: 'cil-car-alt'
        },
        {
          _name: 'CSidebarNavTitle',
          _children: ['Organization']
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Plan',
          to: '/organization-plan',
          icon: 'cil-spreadsheet'
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Vehicle',
          to: '/organization-vehicle',
          icon: 'cil-car-alt'
        },
      ],
      adminMenu: [
        // {
        //   _name: 'CSidebarNavTitle',
        //   _children: ['Control Panel']
        // },
        // {
        //   _name: 'CSidebarNavItem',
        //   name: 'Vehicle',
        //   to: '/Vehicle2',
        //   icon: 'cil-car-alt'
        // },
      ],
    }
  },
  mounted() {
    this.generateMenu()
  },
  watch: {
    isSuspended(newValue, oldValue) {
      // console.log('isSuspended change')
      this.generateMenu()
    },
    isAdministrator(newValue, oldValue) {
      // console.log('isAdministrator change')
      this.generateMenu()
    },
  },
  computed: {
    isAuthenticated () {
      return this.$store.state.isAuthenticated
    },
    isSuspended () {
      return this.$store.state.user.isSuspended
    },
    isAdministrator () {
      return this.$store.state.user.isAdministrator
    },
    show () {
      return this.$store.state.sidebarShow
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    },
  },
  methods: {
    generateMenu () {
      let navList = [
        {
          _name: 'CSidebarNav',
          _children: []
        }
      ]

      let topMenuList = []
      // ### Genetate Public Menu for All user & Prevent with Route Guard
      topMenuList = topMenuList.concat(this.publicMenu)
      // ### Generate User Menu for Active User
      if (this.isSuspended === false) {
        topMenuList = topMenuList.concat(this.userMenu)
      }
      // ### Generate Admin Menu for Administrator
      if (this.isAdministrator) {
        topMenuList = topMenuList.concat(this.adminMenu)
      }
      // ### For Deployment Mode: Display all Core-UI Manu
      // topMenuList = topMenuList.concat(nav[0]._children.slice())

      navList[0]._children = topMenuList
      this.menu = navList;
    }
  }
}
</script>
